import type { FunctionComponent } from "react";

import { Container, IconWrapper, StyledIcon } from "./styles";

type Props = {
  className?: string;
};

export const EmptyButton: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <IconWrapper>
      <StyledIcon /> Listen
    </IconWrapper>
  </Container>
);

EmptyButton.displayName = "EmptyButton";
